<template>
  <v-container>
    <v-row>
      <v-col>
        <v-dialog
          v-model="dialog"
          width="450"
          persistent
        >
          <v-card :disabled="loadingRestorePassword" :loading="loadingRestorePassword">
            <div v-if="!isRestorePassword" class="pa-4">
              <v-card-title>
                Reestablecer contraseña
              </v-card-title>
              <v-card-text class="pb-3">
                <span>Ingresá tu nueva contraseña.</span>
                <v-text-field
                  class="mt-4 font-weight-bold"
                  v-model="password"
                  :error-messages="passwordErrors"
                  label="Contraseña"
                  type="password"
                  required
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                ></v-text-field>
                <v-text-field
                  class="font-weight-bold"
                  v-model="repassword"
                  :error-messages="repasswordErrors"
                  label="Repita Contraseña"
                  type="password"
                  required
                  @input="$v.repassword.$touch()"
                  @blur="$v.repassword.$touch()"
                ></v-text-field>
                <span v-if="errorRestorePassword" class="error--text font-weight-bold body-2">
                  <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                  {{ errorRestorePassword }}
                </span>
              </v-card-text>
              <v-card-actions class="px-5 pt-0">
                <BaseMyButton
                  class="primary mb-4"
                  block
                  color="success"
                  :disabled="$v.$invalid"
                  @click="restorePassword()"
                >
                  <v-icon class="mr-4" small>mdi-content-save</v-icon>
                  Guardar
                </BaseMyButton>
              </v-card-actions>
            </div>
            <div v-else class="pa-4">
              <v-card-title>
                Reestablecer contraseña
              </v-card-title>
              <v-card-text class="pb-3">
                <v-icon color="success" class="mr-2" small>mdi-check-circle</v-icon><span>Contraseña restablecida con exito.</span>
                <div class="d-flex">
                  <BaseMyButton
                    class="mt-4 mx-auto"
                    borderRadius="100"
                    :to="{ name: 'home' }"
                  >
                    Volver a inicio
                  </BaseMyButton>
                </div>
              </v-card-text>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, sameAs, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    password: { required, minLength: minLength(8) },
    repassword: {
      sameAsPassword: sameAs("password")
    }
  },
  props: {
    token: {
      type: String,
    },
  },
  data() {
    return {
      dialog: true,
      isRestorePassword: false,
      loadingRestorePassword: false,
      errorRestorePassword: '',
      password: '',
      repassword: '',
    }
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
        errors.push("Por favor ingrese Contraseña");
      !this.$v.password.minLength &&
        errors.push("La contraseña debe tener una longitud mínima de 8 caracteres");
      return errors;
    },
    repasswordErrors() {
      const errors = [];
      if (!this.$v.repassword.$dirty) return errors;
      !this.$v.repassword.sameAsPassword &&
        errors.push("Las contraseñas no coinciden");
      return errors;
    },
  },
  methods: {
    restorePassword() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.errorRestorePassword = '';
      this.loadingRestorePassword = true;
      this.axios
        .patch(`/api/auth/restaurar-password/${this.token}`, { password: this.password })
        .then(res => {
          this.isRestorePassword = true;
          this.password = '';
          this.repassword = '';
          this.$v.$reset();
        })
        .catch(err => {
          this.$router.push({ name: 'restore password error', params: { token: this.token } });
          if (err.response) this.errorRestorePassword = err.response.data.message;
        })
        .finally(() => {
          this.loadingRestorePassword = false;
        });
    }
  },
}
</script>

<style>

</style>